import React from "react";
import { useNavigate } from "react-router-dom"
import { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { Container, Typography, Box } from "@mui/material"
import BgContainer2 from "./CommonC/BgContainer2";
import SelexSolNavbar from "./CommonC/SelexSolNavbar";
import { Paper } from "@mui/material";
import { baseURL } from "../Config/config";
import GlobalLoader from "./CommonC/GlobalLoader";
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import InstagramIcon from "@mui/icons-material/Instagram";
import { IconButton } from "@mui/material";
import { TextField, Button } from "@mui/material"

import Projectcolors from "../Utils/Colors";



const stylec = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 1000,
  height: 480,
  bgcolor: "white",
  border: "0px solid #000",
  p: 4,
  display: "block",
};


function ReviewBlogPreview(){
    const navigate = useNavigate()
    
    const handleOpenc = () => setOpenc(true);
    const handleOpen = () => setOpen(true);
    const [openc, setOpenc] = React.useState(false);
    const [open, setOpen] = React.useState(false);
    const [blog, setBlog] = React.useState({});
      const handleClosec = () => setOpenc(false);
      const [loader, setLoader] = React.useState(false);
      const [comments,setComments] = useState([])
const [name,setName] = useState("")
const [email,setEmail] = useState("")
const [comment,setComment] = useState("")
const [replyText, setReplyText] = useState("")
const [replyName, setReplyName] = useState("")

const [activeReply, setActiveReply] = useState(null)



      

const {slug} = useParams()
const shareUrl = `https://selexsuite.com/blog/${slug}?v=${Date.now()}`;
useEffect(async () => {
    await displayReviewBlog();
    //await getComments();
  }, []);
  const getComments = async ()=>{

let res = await fetch(`${baseURL}/getcomments/${slug}`)
res = await res.json()

setComments(res.comments)

}


const displayReviewBlog = async ()=>{
    setLoader(true)

  const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(slug),
      };
      try {
        let res = await fetch(`${baseURL}/displayreviewblog`, requestOptions);
        res = await res.json();
        console.log(res)
        setBlog(res['blog'] || {})
        setLoader(false)
       
      } catch (error) {
        setLoader(false)

        alert("Some Error", error);
        console.log("err", error);
      }

}



const publishBlog = async (blogId) => {

  try {

    let res = await fetch(
      `${baseURL}/admin/blogs/${blogId}/publish`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json"
        }
      }
    );

    res = await res.json();

    if (res.code) {
      navigate('/blogs')

    } else {
      alert(res.message || "Unable to publish blog");
    }

  } catch (error) {
    console.log(error);
    alert("Some Error");
  }
};


return (


  <Box
    sx={{
      minHeight: "100vh",
      background:"#fff",
      overflowX: "hidden",
    }}
  >
    <SelexSolNavbar isLoggedIn={!!sessionStorage.getItem("usertoken")}/>

    <Container maxWidth="lg" sx={{ pt: { xs: 2, md: 4 }, pb: 7 }}>
      {/* ARTICLE HEADER */}
      <Box sx={{ textAlign: "center", mb: 4 }}>
        <Typography
          sx={{
            color: "#9e0b22",
            fontSize: 12,
            fontWeight: 950,
            letterSpacing: 1.4,
            textTransform: "uppercase",
            mb: 1,
          }}
        >
          Blog Article
        </Typography>

        <Typography
          sx={{
            fontSize: { xs: 22, md: 44 },
            fontWeight: 700,
            color: "#082f56",
            letterSpacing: "-1.8px",
            lineHeight: 1.12,
            mb: 2,
          }}
        >
          {blog.title}
        </Typography>

        <Typography
          sx={{
            color: "#000",
            fontSize: 16,
            fontWeight: 700,
          }}
        >
          By {blog.author}
        </Typography>
      </Box>

      {/* FEATURE IMAGE */}
      <Box
        sx={{
          position: "relative",
          borderRadius: "34px",
          overflow: "hidden",
          boxShadow: "0 24px 70px rgba(6,29,52,0.16)",
          mb: 4,
        }}
      >
        <Box
          component="img"
          src={blog.image}
          alt={blog.title}
          sx={{
            width: "100%",
            height: { xs: 260, md: 460 },
            objectFit: "cover",
            display: "block",
          }}
        />

        <Box
          sx={{
            position: "absolute",
            inset: 0,
            background:
              "linear-gradient(to top, rgba(6,29,52,0.72), transparent 60%)",
          }}
        />

      </Box>

      {/* ARTICLE CONTENT CARD */}
      <Box
        sx={{
          background: "rgba(255,255,255,0.94)",
          border: "1px solid rgba(0,120,201,0.13)",
          borderRadius: "32px",
          boxShadow: "0 18px 50px rgba(6,29,52,0.08)",
          p: { xs: 3, md: 5 },
          mb: 4,
        }}
      >
       <Box
  className="blog-content"
  sx={{
    fontFamily: "Arial, Helvetica, sans-serif",

    fontSize: {
      xs: "16px",
      md: "17px",
    },

    lineHeight: 1.65,

    color: "#334155",

    "& p": {
      marginTop: 0,
      marginBottom: "12px",
    },

    "& h1": {
      fontSize: {
        xs: "30px",
        md: "36px",
      },
      lineHeight: 1.2,
      fontWeight: 800,
      color: "#061d34",
      marginTop: "30px",
      marginBottom: "16px",
    },

    "& h2": {
      fontSize: {
        xs: "26px",
        md: "30px",
      },
      lineHeight: 1.25,
      fontWeight: 800,
      color: "#061d34",
      marginTop: "26px",
      marginBottom: "14px",
    },

    "& h3": {
      fontSize: {
        xs: "21px",
        md: "24px",
      },
      lineHeight: 1.3,
      fontWeight: 700,
      color: "#061d34",
      marginTop: "22px",
      marginBottom: "12px",
    },

    "& ul, & ol": {
      marginTop: "12px",
      marginBottom: "12px",
      paddingLeft: "28px",
    },

    "& li": {
      marginBottom: "6px",
    },

    "& blockquote": {
      borderLeft: "4px solid #0078c9",
      margin: "20px 0",
      padding: "12px 20px",
      background: "#f8fbff",
      color: "#475569",
    },

    "& img": {
      maxWidth: "100%",
      height: "auto",
      display: "block",
      margin: "22px auto",
      borderRadius: "18px",
      boxShadow: "0 14px 34px rgba(6,29,52,0.10)",
    },

    "& a": {
      color: "#0078c9",
      fontWeight: 600,
      textDecoration: "underline",
    },

    "& iframe": {
      maxWidth: "100%",
      width: "100%",
      minHeight: "420px",
      border: 0,
      borderRadius: "16px",
      margin: "22px 0",
    },
  }}
  dangerouslySetInnerHTML={{ __html: blog.content }}
/>
      </Box>

   <Button
  variant="contained"
  onClick={() => publishBlog(blog._id)}
   sx={{
            height: "52px",
            minWidth: "190px",
            borderRadius: "12px",
            fontWeight: 700,
            fontSize: "15px",
            textTransform: "none",
            background:
              "#0078c9",
            boxShadow:
              "0 10px 25px rgba(0,120,201,0.25)",
            ":hover": {
              background:
                "#0078c9",
            },
          }}
>
  Publish
</Button>
    </Container>

    {loader ? <GlobalLoader /> : null}
  </Box>
);

}


const primaryBtn = {
  px: 3,
  py: 1.25,
  borderRadius: "999px",
  background: "linear-gradient(135deg, #0078c9, #005b98)",
  color: "#fff",
  fontWeight: 900,
  fontSize:14,
  textTransform: "none",
  boxShadow: "0 14px 34px rgba(0,120,201,0.28)",
  "&:hover": {
    background: "linear-gradient(135deg, #9e0b22, #75081a)",
    transform: "translateY(-2px)",
    boxShadow: "0 18px 40px rgba(158,11,34,0.28)",
  },
};

const smallPrimaryBtn = {
  mt: 1,
  px: 2.2,
  py: 0.8,
  borderRadius: "999px",
  background: "#0078c9",
  color: "#fff",
  fontWeight: 800,
  fontSize:14,
  textTransform: "none",
  "&:hover": {
    background: "#9e0b22",
  },
};

const fieldStyle = {
  mb: 2,
  "& .MuiInputLabel-root": {
      fontSize: "14px",
    },
  "& .MuiOutlinedInput-root": {
    borderRadius: "16px",
    fontSize: "16px",
    "& fieldset": {
      borderColor: "rgba(0,120,201,0.16)",
    },
    "&:hover fieldset": {
      borderColor: "#0078c9",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#0078c9",
    },
  },
  "& .MuiInputLabel-root.Mui-focused": {
    color: "#0078c9",
  },
};

export default ReviewBlogPreview;